import React, { useEffect, useMemo, useState } from "react";

import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import SelectQ from "../../../components/FormComponents/SelectQ/SelectQ";
import ErrorMessage from "../../../components/TableBionovaQ/ErrorMessage/ErrorMessage";
import InputQ from "../../../components/FormComponents/InputQ/InputQ";

import request from "../../../utils/request";

import styles from "./SterilizerProgramForm.module.css";
import { getSession, getUserId } from "../../../utils/sessionHandler";
import CheckBoxQ from "../../../components/FormComponents/CheckBoxQ/CheckBoxQ";

const SterilizerProgramForm = ({
  formData,
  handleFormData,
  handleClose,
  open,
  locale,
  t,
  brands,
  models,
  getPackagesTypes,
  selectedSector,
  handleModalBrand,
  handleModalModel,
  sterilizers,
}) => {
  const [error, setError] = useState("");
  const [validate, setValidate] = useState(false);
//   const [temperatureOptions, setTemperatureOptions] = useState([]);
console.log(formData)
  const timeUnitOptions = [
    { value: "Minutes", name: t("MinuteSpan") || "Minutes" },
    { value: "Seconds", name: t("SecondSpan") || "Seconds" },
  ];

  const temperatureOptions = [
    { value: "Celsius", name: t("CelsiusSpan") || "Celsius" },
    { value: "Fahrenheit", name: t("FahrenheitSpan") || "Fahrenheit" },
  ];

  const loggedUserId = getUserId();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.programName
    ) {
      setValidate(true);
      return;
    } else setValidate(false);

    try {
      const bodyRequest = {
        ...formData
      };
      if (formData.id) {
        await request().put("/api/sterilizerProgram", bodyRequest);
      } else {
        await request().post("/api/sterilizerProgram", bodyRequest);
      }
      handleClose();
      setError("");
      setValidate(false);
      getPackagesTypes()
    } catch (err) {
      setError(
        err.response?.data?.message || "Error al guardar el esterilizador."
      );
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    handleFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleBrandChange = (e) => {
    const { name, value } = e.target;
    const brandName = brands.find((b) => value == b.value)?.name;
    handleFormData((prevData) => ({
      ...prevData,
      [name]: value,
      brand: brandName,
      companyMachineModelId: "",
      methodName: "",
    }));
  };

  const handleModelChange = (e) => {
    let model = models.find((m) => m.value == e.target.value);
    const brandName = brands.find((b) => model?.brandId == b.value)?.name;

    if (model) {
      handleFormData((prevData) => ({
        ...prevData,
        companyMachineModelId: model.value,
        companyMachineMakeId: model.brandId,
        methodName: model.methodName,
        brand: brandName,
      }));
    } else {
      handleFormData((prevData) => ({
        ...prevData,
        companyMachineModelId: "",
        companyMachineMakeId: "",
        brand: "",
        methodName: "",
      }));
    }
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    handleFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    })); 
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    
    handleFormData((prevData) => ({ ...prevData, [name]: value }));
  };

//   useEffect(() => {
//     const fetchAppParameter = request().get(
//       `/api/appparameter?userLoggedId=${loggedUserId}`
//     );
//     const fetchTemperatureUnit = request().get(
//       `/api/temperatureunit?userLoggedId=${loggedUserId}`
//     );

//     Promise.all([fetchAppParameter, fetchTemperatureUnit])
//       .then(([appParameterRes, temperatureUnitRes]) => {
//         const appParameterData = appParameterRes.data;
//         const temperatureUnitData = temperatureUnitRes.data.map((item) => ({
//           value: item.id,
//           name: item.description,
//         }));

//         handleFormData((prevData) => ({
//           ...prevData,
//           temperatureUnit:
//             formData.chargeStatus === 4
//               ? temperatureUnitData.find(
//                   (t) => t.name === formData.temperatureUnit
//                 )?.value || ""
//               : appParameterData[8].value || "",
//         }));
//         setTemperatureOptions(temperatureUnitData);
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }, []);


  const onClose = () => {
    handleClose();
    setError("");
    setValidate(false);
  };

  return (
    <ModalQ
      open={open}
      title={
        !formData.id
          ? t("New Program", locale) || "New Program"
          : t("Edit Program", locale) || "Edit Program"
      }
      handleClose={onClose}
    >
      {error && <ErrorMessage message={error} />}
      <div className={styles.container}>
        <div className={styles.inputGroup}>
          <InputQ
            label={t("Name", locale) || "Name"}
            name="programName"
            handleChange={handleInputChange}
            value={formData.programName}
            required={true}
            validate={validate}
            labelTop={true}
            containerWidth={"48%"}
            leftMessage={true}
          />
           <div className={styles.itemWithForm}>
           <SelectQ
          selectValue={formData.sterilizerId}
          handleSelect={handleSelectChange}
          options={sterilizers}
          name={"sterilizerId"}
          label={t("SelectASterilizer") || "Select a Sterilizer"}
          labelTop={true}
          // hasPlaceholder={true}
          placeholder={t("SelectASterilizer") || "Select a Sterilizer"}
          required={true}
          errorMessage={t("RequiredField") || "This field is required"}
          validate={validate}
        />
          </div>
        </div>
        <div className={styles.inputGroup}>
        <div className={styles.inputGroup}>
        <div style={{ width: "48%", gap: "10px" }} className={styles.inputGroup}>
          <InputQ
            label={t("SterilizationTimeSpan") || "Sterilization Time"}
            name="cicleTime"
            handleChange={handleInputChange}
            value={formData.cicleTime}
            containerWidth="68%"
            type="number"
            min={0}
            labelTop={true}
          />
          <SelectQ
            selectValue={formData.timeUnit}
            handleSelect={handleSelectChange}
            name={"timeUnit"}
            width={"100%"}
            containerWidth={"30%"}
            options={timeUnitOptions}
          />
        </div>
        <div style={{ width: "48%", gap: "10px" }} className={styles.inputGroup}>
          <InputQ
            label={t("TemperatureSpan") || "Temperature"}
            name="cicleTemperature"
            handleChange={handleInputChange}
            value={formData.cicleTemperature}
            containerWidth="68%"
            type="number"
            min={0}
            labelTop={true}
          />
          <SelectQ
            selectValue={formData.temperatureUnit}
            handleSelect={handleSelectChange}
            name={"temperatureUnit"}
            width={"100%"}
            containerWidth={"30%"}
            options={temperatureOptions}
          />
        </div>
      </div>
    </div>

        <button
          className={`${styles.button} ${styles.confirmButton}`}
          onClick={(e) => handleSubmit(e)}
        >
          Confirm
        </button>
      </div>
    </ModalQ>
  );
};

export default SterilizerProgramForm;